import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CoreDataContextService } from '../services/core.data.context.service';
import { CoreDataActions } from './core.data.actions';
import { CoreDataActionName } from './core.data.state';

@Injectable()
export class CoreDataEffects {
  private api = '/api';
  constructor(
    private http: HttpClient,
    private actions$: Actions,
    private coreActions: CoreDataActions,
    private context: CoreDataContextService
  ) { }

  
  categories$ = createEffect(() => this.actions$
    .pipe(
      ofType(CoreDataActionName.CategoriesLoadAll),
      switchMap(x =>
        this.http
          .get(this.api + '/categories/')
          .pipe(
            map(response => this.coreActions.actionSuccess(CoreDataActionName.CategoriesLoadAll, response)),
            catchError(error => of(this.coreActions.actionFailed(CoreDataActionName.CategoriesLoadAll, error, false)))
          )
      )
    ));


  
  codes$ = createEffect(() => this.actions$
    .pipe(
      ofType(CoreDataActionName.CodesLoadAll),
      switchMap(x =>
        this.http
          .get(this.api + '/codes/')
          .pipe(
            map(response => this.coreActions.actionSuccess(CoreDataActionName.CodesLoadAll, response)),
            catchError(error => of(this.coreActions.actionFailed(CoreDataActionName.CodesLoadAll, error, false)))
          )
      )
    ));

  
  companies$ = createEffect(() => this.actions$
    .pipe(
      ofType(CoreDataActionName.CompaniesLoadAll),
      switchMap(x =>
        this.http
          .get(this.api + '/companies/')
          .pipe(
            map(response => this.coreActions.actionSuccess(CoreDataActionName.CompaniesLoadAll, response, false)),
            catchError(error => of(this.coreActions.actionFailed(CoreDataActionName.CompaniesLoadAll, error, false)))
          )
      )
    ));

  
  jobTypes$ = createEffect(() => this.actions$
    .pipe(
      ofType(CoreDataActionName.JobTypesLoadAll),
      switchMap(x =>
        this.http
          .get(this.api + '/jobtypes/')
          .pipe(
            map(response => this.coreActions.actionSuccess(CoreDataActionName.JobTypesLoadAll, response)),
            catchError(error => of(this.coreActions.actionFailed(CoreDataActionName.JobTypesLoadAll, error, false)))
          )
      )
    ));

  
  priorities$ = createEffect(() => this.actions$
    .pipe(
      ofType(CoreDataActionName.PrioritiesLoadAll),
      switchMap(x =>
        this.http
          .get(this.api + '/priorities/')
          .pipe(
            map(response => this.coreActions.actionSuccess(CoreDataActionName.PrioritiesLoadAll, response)),
            catchError(error => of(this.coreActions.actionFailed(CoreDataActionName.PrioritiesLoadAll, error, false)))
          )
      )
    ));

  
  workorderStatuses$ = createEffect(() => this.actions$
    .pipe(
      ofType(CoreDataActionName.WorkorderStatusLoadAll),
      switchMap(x =>
        this.http
          .get(this.api + '/workorderstatuses/')
          .pipe(
            map(response => this.coreActions.actionSuccess(CoreDataActionName.WorkorderStatusLoadAll, response)),
            catchError(error => of(this.coreActions.actionFailed(CoreDataActionName.WorkorderStatusLoadAll, error, false)))
          )
      )
    ));

  
  quoteStatuses$ = createEffect(() => this.actions$
    .pipe(
      ofType(CoreDataActionName.QuoteStatusLoadAll),
      switchMap(x =>
        this.http
          .get(this.api + '/quotestatuses/')
          .pipe(
            map(response => this.coreActions.actionSuccess(CoreDataActionName.QuoteStatusLoadAll, response)),
            catchError(error => of(this.coreActions.actionFailed(CoreDataActionName.QuoteStatusLoadAll, error, false)))
          )
      )
    ));

  
  users$ = createEffect(() => this.actions$
    .pipe(
      ofType(CoreDataActionName.UsersLoadAll),
      switchMap(x =>
        this.http
          .get(this.api + '/users/')
          .pipe(
            map(response => this.coreActions.actionSuccess(CoreDataActionName.UsersLoadAll, response)),
            catchError(error => of(this.coreActions.actionFailed(CoreDataActionName.UsersLoadAll, error, false))
            )
          )
      )
    ));

  
  customers$ = createEffect(() => this.actions$
    .pipe(
      ofType(CoreDataActionName.CustomersLoadAll),
      switchMap(x =>
        this.http
          .get(this.api + '/customers/')
          .pipe(
            map(response => this.coreActions.actionSuccess(CoreDataActionName.CustomersLoadAll, response)),
            catchError(error => of(this.coreActions.actionFailed(CoreDataActionName.CustomersLoadAll, error, false)))
          )
      )
    ));

  
  zones$ = createEffect(() => this.actions$
    .pipe(
      ofType(CoreDataActionName.ZonesLoadAll),
      switchMap(x =>
        this.http
          .get(this.api + '/zones')
          .pipe(
            map(response => this.coreActions.actionSuccess(CoreDataActionName.ZonesLoadAll, response)),
            catchError(error => of(this.coreActions.actionFailed(CoreDataActionName.ZonesLoadAll, error, false)))
          )
      )
    ));

  
  documents$ = createEffect(() => this.actions$
    .pipe(
      ofType(CoreDataActionName.DocumentsLoadAll),
      switchMap(x =>
        this.http
          .get(this.api + '/documentlibrary')
          .pipe(
            map(response => this.coreActions.actionSuccess(CoreDataActionName.DocumentsLoadAll, response)),
            catchError(error => of(this.coreActions.actionFailed(CoreDataActionName.DocumentsLoadAll, error, false)))
          )
      )
    ));
}
